package helpers

import emotion.react.useTheme
import react.use.useMediaQuery
import react.useContext
import ui.themePlusContext.MyContext
import web.cssom.MediaQuery

fun isPhone() = useMediaQuery(MediaQuery("(max-width: 768px)"))

fun isMiniDesktop() = useMediaQuery(MediaQuery("(min-width: 1050px)"))